import React, { useContext } from 'react';
import { Context as CountriesContext } from '../context/CountriesContext';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { GLOBAL_IDENTIFIER } from '../utils';

function CountryMenu() {
  const {
    state: { countries, selectedCountry },
    setSelectedCountry
  } = useContext(CountriesContext);

  const onChangeSelected = event => setSelectedCountry(event.target.value);
  // TODO: add flag to menu
  return (
    <div>
      <FormControl className="menu">
        <Select onChange={onChangeSelected} variant="outlined" value={selectedCountry}>
          <MenuItem value={GLOBAL_IDENTIFIER}>Global</MenuItem>

          {countries.slice(0, countries.length - 1).map(country => (
            <MenuItem
              key={`${country.countryInfo._id}-menu-item`}
              value={country.countryInfo.iso2}>
              {country.country}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default CountryMenu;
